/*
* @version 1.1
* @changelog
*	1.1 zabaleni zpet
*
*/


(function($) {

	$.fn.expandableTextBox = function(maxHeight) {

		return this.each(function() {

			var $this = $(this);
			var $expander = $this.find(".expander").eq(0);
			var $unexpander = $this.find(".unexpander");
			var $content = $this.find(".expander-content");

			if ($this.height() > maxHeight) {

				$expander.find("a").click(function() {
					$content.css("max-height", "none");
					$this.removeClass("enabled-expanding");
					$unexpander.show();
					$expander.hide();
					return false;
				});

				$unexpander.find("a").click(function() {
					$content.css("max-height", maxHeight + "px");
					$this.addClass("enabled-expanding");
					$unexpander.hide();
					$expander.show();
					return false;
				});

				$unexpander.hide();

				$content.css("max-height", maxHeight + "px");
				$this.addClass("enabled-expanding");

			} else {					
				$expander.remove();
				$unexpander.remove();
			}

		});

	};

})(jQuery);